import React from "react";
import "./CampaignCard.css";
import CampaignOutlinedIcon from "@mui/icons-material/CampaignOutlined";
import SendTimeExtensionOutlinedIcon from "@mui/icons-material/SendTimeExtensionOutlined";
import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import ContentCopyRoundedIcon from "@mui/icons-material/ContentCopyRounded";
import PeopleOutlineRoundedIcon from "@mui/icons-material/PeopleOutlineRounded";
const CampaignCard = (props) => {
  const {
    campaignTitle,
    date,
    campaignSource,
    campaignType,
    leads,
    property,
    template,
    onEdit,
    onDelete,
    onClick,
  } = props;

  return (
    <div
      className="campaign-listing-card"
      onClick={(e) => {
        e.preventDefault();
        onClick();
      }}
    >
      <div className="listing-card-header">
        <div className="left">
          <div>
            <div className="name">{campaignTitle}</div>
            <div className="date">
              Added on:{" "}
              <span
                style={{
                  color: "#929292",
                }}
              >
                {date}
              </span>
            </div>
          </div>
        </div>
        <div className="right">
          <span
            className="icon"
            onClick={(e) => {
              e.stopPropagation();
              onDelete();
            }}
          >
            <DeleteOutlineRoundedIcon className="delete-icon" />
          </span>

          <span
            className="icon"
            onClick={(e) => {
              e.stopPropagation();
              onEdit();
            }}
          >
            <ContentCopyRoundedIcon className="update-icon" />
          </span>
        </div>
      </div>

      <div className="listing-card-body">
        {campaignSource && (
          <div className="card-element">
            <div className="icon">
              <CampaignOutlinedIcon />
            </div>
            <div className="detail">{campaignSource}</div>
          </div>
        )}
        {campaignType && (
          <div className="card-element">
            <div className="icon">
              <SendTimeExtensionOutlinedIcon />
            </div>
            <div className="detail">{campaignType}</div>
          </div>
        )}
        {leads && (
          <div className="card-element">
            <div className="icon">
              <PeopleOutlineRoundedIcon />
            </div>
            <div className="detail">{leads.length}</div>
          </div>
        )}
        {/* {property && (
          <div className="card-element">
            <div className="icon">
              <img src={locationIcon} />
            </div>
            <div className="detail">{property.id}</div>
          </div>
        )} */}
      </div>
    </div>
  );
};

export default CampaignCard;
